var _rect, _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6068_10189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H62V62H18V18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6068_10189)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1649 57.0302C42.9581 58.8232 45.8651 58.8233 47.6582 57.0302C48.1256 56.5628 48.4727 56.0169 48.6971 55.4337L60.069 25.8667C60.6994 24.2279 60.3558 22.2954 59.0302 20.9698C57.7046 19.6442 55.7722 19.3006 54.1334 19.931L24.5665 31.3029C23.9832 31.5272 23.4372 31.8744 22.9699 32.3417C21.1767 34.1348 21.1767 37.042 22.9699 38.8351C23.5587 39.4239 24.2713 39.8213 25.0256 40.0232L35.7936 42.9076C36.0937 42.9879 36.3777 43.1454 36.6162 43.3838C36.8546 43.6223 37.0121 43.9061 37.0925 44.2064L39.9767 54.9743C40.1787 55.7286 40.5762 56.4414 41.1649 57.0302ZM42.4158 53.4517L39.7489 43.4949C39.5469 42.7409 39.1497 42.0283 38.5607 41.4393C37.9719 40.8505 37.2591 40.4531 36.505 40.2512L25.7368 37.3668C25.4367 37.2865 25.1528 37.129 24.9144 36.8905C24.1952 36.1714 24.1954 35.0053 24.9145 34.2862C25.1042 34.0965 25.3222 33.9586 25.5535 33.8696L52.9434 23.335L55.1206 22.4976C55.782 22.2432 56.5561 22.3848 57.0857 22.9144C57.6152 23.4439 57.7568 24.218 57.5023 24.8794L46.1304 54.4464C46.0413 54.6779 45.9035 54.8959 45.7137 55.0856C44.9946 55.8047 43.8287 55.8047 43.1094 55.0856C42.8709 54.8471 42.7135 54.563 42.6332 54.263L42.4158 53.4517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7465 61.2535C19.2834 61.7905 20.1541 61.7905 20.691 61.2535L27.9831 53.9615C28.52 53.4245 28.52 52.5539 27.9831 52.0169C27.4461 51.48 26.5755 51.48 26.0385 52.0169L18.7465 59.309C18.2095 59.8459 18.2095 60.7166 18.7465 61.2535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4691 61.2535C29.0061 61.7905 29.8767 61.7905 30.4137 61.2535L35.275 56.3922C35.812 55.8552 35.812 54.9846 35.275 54.4477C34.738 53.9107 33.8674 53.9107 33.3304 54.4477L28.4691 59.309C27.9322 59.8459 27.9322 60.7166 28.4691 61.2535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7465 51.527C19.2834 52.0639 20.1541 52.0639 20.691 51.527L25.5523 46.6656C26.0893 46.1287 26.0893 45.2581 25.5523 44.7211C25.0154 44.1841 24.1448 44.1841 23.6078 44.7211L18.7465 49.5824C18.2095 50.1194 18.2095 50.99 18.7465 51.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2865 38.7145C41.8235 39.2514 42.6941 39.2514 43.2311 38.7145L50.5231 31.4224C51.0601 30.8854 51.0601 30.0148 50.5231 29.4779C49.9861 28.9409 49.1155 28.9409 48.5786 29.4779L41.2865 36.7699C40.7495 37.3069 40.7495 38.1775 41.2865 38.7145Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.334887de.svg";
export { ForwardRef as ReactComponent };